import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TAllUsersAIDescriptionsData } from "../../Types";
import { post } from "../axios-post";
export const apiCallGetAllUsersAIDescriptions = async ({
  limit,
  offset
}: {
  limit: number;
  offset: number;
}): Promise<{
  data: TAllUsersAIDescriptionsData;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TAllUsersAIDescriptionsData>(
    `developer/getAllUsersAIDescriptions`,
    {
      limit,
      offset
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
